
import { Link } from "react-router-dom";
import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";

export const Footer = () => {
  let theme = 'light';
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
  } catch {
    // Default to dark if not within provider
  }

  const isDark = theme === 'dark';
  const bgColor = isDark ? 'bg-[#0a0a0a]' : 'bg-[#f5f5f5]';
  const textColor = isDark ? 'text-white' : 'text-gray-900';
  const mutedTextColor = isDark ? 'text-gray-300' : 'text-gray-600';
  const borderColor = isDark ? 'border-gray-800' : 'border-gray-300';
  const legalTextColor = isDark ? 'text-gray-400' : 'text-gray-500';
  const hoverTextColor = isDark ? 'hover:text-white' : 'hover:text-gray-900';

  return (
    <footer className={`${bgColor} ${textColor} py-4 md:py-8 px-4 pb-20 md:pb-8 transition-colors duration-500`}>
      <div className="max-w-7xl mx-auto">
        {/* Navigation Section */}
        <div className="mb-4 md:mb-8">
          <h3 className="text-[#e4683b] text-lg font-medium mb-4">Navigation</h3>
          
          {/* Desktop: 4 columns, Mobile: 2 columns */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-3 text-sm">
            <Link to="/" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              Home
            </Link>
            <Link to="/who-we-are" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              Who We Are
            </Link>
            <Link to="/mission" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              Our Mission
            </Link>
            <Link to="/vision" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              Our Vision
            </Link>
            <Link to="/why-uda" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              Why UDA?
            </Link>
            <Link to="/our-work" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              Our Work
            </Link>
            <Link to="/landing" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              UDA Wizard
            </Link>
            <Link to="/uda-models" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              UDA Models
            </Link>
            <Link to="/adu-calculator" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              Calculator
            </Link>
            <Link to="/follow-us" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              Follow Us
            </Link>
            <Link to="/faq" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              FAQ
            </Link>
            <Link to="/contact-us" className={`${mutedTextColor} ${hoverTextColor} transition-colors`}>
              Contact Us
            </Link>
          </div>
        </div>

        {/* Logo and License Section */}
        <div className={`text-center border-t ${borderColor} pt-3 md:pt-6`}>
          {/* Logo */}
          <div className="mb-2 md:mb-4">
            <Link to="/">
              <video 
                src="https://wrghlmsinvhwvvfhhrvj.supabase.co/storage/v1/object/sign/VIDEOS/UPDATED%20OFFICIAL%20LOGO%20VIDEO%20.m4v?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8zMWY3NTE2YS1mMTNjLTQ2MzEtYTliMC1mOWJmMGFjNTBkZjMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJWSURFT1MvVVBEQVRFRCBPRkZJQ0lBTCBMT0dPIFZJREVPIC5tNHYiLCJpYXQiOjE3NTMyMTA3ODksImV4cCI6MjA2ODU3MDc4OX0.OsUvgtIF-9jWpNHQ01Md219Rwylph-NiLR0_biMPjck"
                className="h-16 mx-auto" 
                autoPlay 
                loop 
                muted 
                playsInline
              />
            </Link>
          </div>
          
          {/* Slogan */}
          <div className="mb-3 md:mb-6 text-center">
            <p className="text-[#e4683b] text-base font-light">
              <span className="font-bold">U</span>plift Value . <span className="font-bold">D</span>ream Realistically . <span className="font-bold">A</span>uthentic Craftsmanship
            </p>
          </div>
          
          {/* License and Copyright */}
          <div className="mb-3 md:mb-6">
            <div className={`${legalTextColor} text-sm mb-1 md:mb-2`}>
              CSLB License # 1146840
            </div>
            <div className={`${legalTextColor} text-sm`}>
              © 2026 UDA ADU. All rights reserved.
            </div>
          </div>
          
          {/* Legal Links */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-sm">
            <Link to="/privacy-policy" className={`${legalTextColor} ${hoverTextColor} transition-colors`}>
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" className={`${legalTextColor} ${hoverTextColor} transition-colors`}>
              Terms & Conditions
            </Link>
            <Link to="/cookie-policy" className={`${legalTextColor} ${hoverTextColor} transition-colors`}>
              Cookie Policy
            </Link>
            <a href="#" className={`termly-display-preferences ${legalTextColor} ${hoverTextColor} transition-colors`}>
              Consent Preferences
            </a>
            <Link to="/preferences" className={`${legalTextColor} ${hoverTextColor} transition-colors`}>
              Preferences
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
